export default {
  dashboard: state => state.dashboard,
  clientReview: state => state.clientReview,
  clientInspections: state => state.clientInspections
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js